module.exports = __webpack_public_path__ + "img/DS8208x10PP_Large.b1b2e853.jpg";